import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "user-detail",
    title: "รายละเอียดผู้ใช้",
    summary:
      "หน้ารวมทุกอย่างของบัญชีผู้ใช้หนึ่งคน: ข้อมูลโปรไฟล์ อีเมล/เบอร์โทร/รหัสผู้ใช้งาน/ชื่อผู้ใช้ที่ใช้เข้าสู่ระบบ รหัสผ่านและ 2FA สิทธิ์เข้าแอปพลิเคชัน บทบาทคอนโซล เซสชันที่ใช้งานอยู่ ประวัติกิจกรรม รวมถึงการระงับและลบบัญชี",
    access:
      'ผู้ที่มีสิทธิ์อ่านผู้ใช้เปิดดูได้ (owner, admin, auditor) การแก้ไขต้องมีสิทธิ์แก้ไขผู้ใช้ การลบต้องมีสิทธิ์ลบผู้ใช้ แท็บ "บทบาท" และ "กิจกรรม" แสดงเฉพาะผู้ที่มีสิทธิ์อ่านบทบาทและบันทึกการใช้งาน ปุ่มที่คุณไม่มีสิทธิ์จะไม่แสดง และช่องที่แก้ไม่ได้จะเป็นสีเทา',
    shot: {
      file: "user-detail-page.png",
      caption: "หน้ารายละเอียดผู้ใช้: การ์ดข้อมูลสรุปด้านบน แท็บต่าง ๆ และโซนอันตรายด้านล่าง",
    },
    sections: [
      {
        id: "open",
        heading: "เปิดหน้ารายละเอียดผู้ใช้",
        body: [
          'ในหน้า "ผู้ใช้" ค้นหาผู้ใช้แล้วกดที่แถวของเขา หน้ารายละเอียดจะเปิดขึ้น กดลิงก์ "กลับไปหน้าผู้ใช้" ที่มุมซ้ายบนเพื่อกลับไปยังรายชื่อ',
          'หน้านี้แบ่งเป็น 3 การ์ด: การ์ดข้อมูลสรุป การ์ดแท็บ (โปรไฟล์ อีเมล/เบอร์โทร ความปลอดภัย สิทธิ์เข้าถึง บทบาท เซสชัน กิจกรรม) และการ์ด "โซนอันตราย"',
        ],
      },
      {
        id: "summary",
        heading: "การ์ดข้อมูลสรุป",
        fieldsTitle: "ข้อมูลในการ์ดสรุป",
        fields: [
          {
            name: "รูป อีเมล และชื่อที่แสดง",
            description:
              'หัวการ์ดแสดงอีเมลหลักของบัญชีและชื่อที่แสดง (บัญชี root แสดงคำว่า root พร้อมป้าย "root" และคำอธิบาย "ผู้ใช้สูงสุดของระบบ — มีแต่ root เองที่แก้ไขบัญชีนี้ได้")',
          },
          {
            name: "ป้ายสถานะ ประเภท และบทบาท",
            description:
              'สถานะ ("ใช้งาน" / "รอยืนยัน" / "ถูกระงับ") ประเภทผู้ใช้ (เช่น employee หรือ "บัญชีระบบ" สำหรับ root) และป้ายของแต่ละบทบาทคอนโซล',
          },
          {
            name: 'ปุ่ม "ส่งออกข้อมูล (PDPA)"',
            description:
              "ดาวน์โหลดข้อมูลทั้งหมดของผู้ใช้คนนี้เป็นไฟล์ JSON (ชื่อไฟล์ user-<รหัสผู้ใช้>.json) ใช้ตอบคำขอใช้สิทธิ์ของเจ้าของข้อมูลตาม PDPA แสดงเฉพาะผู้ที่มีสิทธิ์ส่งออกข้อมูล และการส่งออกทุกครั้งถูกบันทึกในบันทึกการใช้งาน",
          },
          {
            name: "รหัสผู้ใช้",
            description:
              "รหัสประจำบัญชีแบบยาว (UUID) ไม่เปลี่ยนตลอดอายุบัญชี และเป็นรหัสที่แอปพลิเคชันได้รับ กดปุ่มคัดลอกข้าง ๆ เพื่อคัดลอก",
          },
          {
            name: "รหัสผู้ใช้งาน",
            description:
              "แสดงเมื่อผู้ใช้มีรหัสผู้ใช้งาน (รหัสสั้นที่องค์กรออกให้ ใช้เข้าสู่ระบบแทนอีเมล) พร้อมปุ่มคัดลอก",
          },
          {
            name: "ชื่อผู้ใช้",
            description:
              "แสดงเมื่อผู้ใช้มีชื่อผู้ใช้ (ชื่อที่ผู้ใช้ตั้งเอง ใช้เข้าสู่ระบบแทนอีเมลได้) พร้อมปุ่มคัดลอก",
          },
          { name: "สร้างเมื่อ", description: "วันที่สร้างบัญชี" },
          {
            name: "ยืนยันอีเมลแล้ว",
            description:
              '"ใช่" ถ้าผู้ใช้ยืนยันอีเมลหลักแล้ว "ไม่ใช่" ถ้ายังไม่ยืนยัน (สถานะจะเป็น "รอยืนยัน")',
          },
          {
            name: "ถูกระงับ: …",
            description: "กล่องสีแดงแสดงเหตุผลที่ระงับ เมื่อบัญชีถูกระงับอยู่",
          },
        ],
      },
      {
        id: "profile",
        heading: 'แท็บ "โปรไฟล์"',
        body: [
          'ข้อมูลส่วนตัวและข้อมูลพนักงานของผู้ใช้ แก้ไขแล้วกดปุ่ม "บันทึกโปรไฟล์" ที่มุมขวาล่าง จะเห็นข้อความ "บันทึกแล้ว" ถ้าคุณไม่มีสิทธิ์แก้ไข ช่องทั้งหมดจะเป็นสีเทาและไม่มีปุ่มบันทึก',
        ],
        fieldsTitle: "ช่องในแท็บโปรไฟล์",
        fields: [
          {
            name: "ชื่อที่แสดง",
            description: "ชื่อที่แสดงในระบบและส่งให้แอปพลิเคชัน (ไม่ควรเว้นว่าง)",
          },
          {
            name: "รหัสพนักงาน",
            description:
              'รหัสพนักงานตามระบบ HR ต้องไม่ซ้ำกับคนอื่น ถ้าซ้ำจะบันทึกไม่ได้ (ต่างจาก "รหัสผู้ใช้งาน" ซึ่งใช้เข้าสู่ระบบ และตั้งในแท็บ "อีเมล/เบอร์โทร")',
          },
          { name: "ชื่อ", description: "ชื่อจริง" },
          { name: "นามสกุล", description: "นามสกุล" },
          { name: "แผนก", description: "แผนกที่สังกัด (ค้นหาผู้ใช้ด้วยแผนกได้ในหน้ารายชื่อ)" },
          { name: "ตำแหน่ง", description: "ตำแหน่งงาน" },
          {
            name: "ฟิลด์เพิ่มเติม",
            description:
              'ช่องข้อมูลที่องค์กรกำหนดเองในหน้า "ฟิลด์เพิ่มเติม" อาจเป็นข้อความ ตัวเลข วันที่ ใช่/ไม่ใช่ (ช่องติ๊ก) หรือรายการให้เลือก ช่องที่มีเครื่องหมายบังคับต้องกรอก ส่วนนี้แสดงเมื่อองค์กรสร้างฟิลด์ไว้และคุณมีสิทธิ์อ่านการตั้งค่า',
          },
        ],
        tips: [
          "ช่องที่เว้นว่างจะถูกบันทึกเป็นค่าว่าง (ลบข้อมูลเดิมออก)",
          "การแก้ไขโปรไฟล์ไม่ทำให้ผู้ใช้ออกจากระบบ แอปพลิเคชันจะเห็นข้อมูลใหม่เมื่อผู้ใช้เข้าสู่ระบบครั้งถัดไป",
        ],
      },
      {
        id: "identifiers",
        heading: 'แท็บ "อีเมล/เบอร์โทร" (ช่องทางเข้าสู่ระบบ)',
        body: [
          'บัญชีหนึ่งมีได้หลายอีเมล หลายเบอร์โทรศัพท์ รหัสผู้ใช้งานหนึ่งรหัส และชื่อผู้ใช้หนึ่งชื่อ ผู้ใช้เข้าสู่ระบบได้ด้วยรายการใดก็ได้ที่ "ยืนยันแล้ว" และไม่ว่าจะพิมพ์อะไร ก็เข้าบัญชีเดียวกันเสมอ อีเมลหลักคืออีเมลของบัญชีที่แอปพลิเคชันได้รับ',
          'ตารางแสดงทุกรายการ: ค่า (พร้อมไอคอนและประเภท อีเมล / เบอร์โทรศัพท์ / รหัสผู้ใช้งาน / ชื่อผู้ใช้) "สถานะ" (ป้าย "หลัก" และ "ยืนยันแล้ว" หรือ "ยังไม่ยืนยัน") และ "เพิ่มเมื่อ" มีคอลัมน์ "ประเภท" ซ่อนไว้ เปิดได้จากปุ่ม "คอลัมน์"',
        ],
        shot: {
          file: "user-detail-identifiers.png",
          caption:
            'แท็บ "อีเมล/เบอร์โทร": รายการช่องทางเข้าสู่ระบบ และแบบฟอร์ม "เพิ่มอีเมลหรือเบอร์โทรศัพท์"',
        },
        fieldsTitle: 'แบบฟอร์ม "เพิ่มอีเมลหรือเบอร์โทรศัพท์" และเมนูของแต่ละแถว',
        fields: [
          {
            name: "ประเภท",
            required: true,
            description: 'เลือก "อีเมล" "เบอร์โทรศัพท์" "รหัสผู้ใช้งาน" หรือ "ชื่อผู้ใช้"',
          },
          {
            name: "อีเมลหรือเบอร์โทรศัพท์",
            required: true,
            description:
              "ค่าที่จะเพิ่ม · อีเมล เช่น name@example.com · เบอร์โทร เช่น 081 234 5678 (เบอร์ในประเทศจะถูกบันทึกเป็น +66812345678 พิมพ์มีขีดหรือช่องว่างได้) · รหัสผู้ใช้งาน เช่น pc-00123 หรือชื่อผู้ใช้ เช่น somchai.k: 3–32 ตัว ตัวอักษรภาษาอังกฤษ ตัวเลข . _ - ห้ามเป็นตัวเลข 9 หลักขึ้นไป ห้ามซ้ำกับรหัสผู้ใช้งานหรือชื่อผู้ใช้ของใคร",
          },
          {
            name: "ยืนยันแล้ว (ตรวจสอบนอกระบบแล้ว)",
            description:
              "ติ๊กเมื่อคุณตรวจสอบแล้วว่าอีเมล/เบอร์นี้เป็นของผู้ใช้จริง (เช่น ตรวจจากเอกสาร HR) รายการจะใช้เข้าสู่ระบบได้ทันที ถ้าไม่ติ๊ก ผู้ใช้ต้องยืนยันเองด้วยรหัสจากหน้าบัญชีของตนเอง (ระบบไม่ส่งรหัสให้อัตโนมัติตอนผู้ดูแลเพิ่ม) รหัสผู้ใช้งานและชื่อผู้ใช้ถือว่ายืนยันแล้วเสมอ",
          },
          { name: 'ปุ่ม "เพิ่ม"', description: 'เพิ่มรายการ จะเห็นข้อความ "เพิ่มแล้ว"' },
          {
            name: 'เมนู ⋮ → "ทำเครื่องหมายว่ายืนยันแล้ว"',
            description: "แสดงกับรายการที่ยังไม่ยืนยัน ทำให้ใช้เข้าสู่ระบบได้ทันที (บันทึกในบันทึกการใช้งาน)",
          },
          {
            name: 'เมนู ⋮ → "ตั้งเป็นหลัก"',
            description:
              'แสดงกับอีเมลหรือเบอร์ที่ยืนยันแล้วแต่ยังไม่ใช่รายการหลัก สำหรับอีเมลจะมีหน้าต่างยืนยัน "ตั้งเป็นอีเมลหลัก?": แอปพลิเคชันจะได้รับอีเมลนี้แทน และอีเมลหลักเดิมกลายเป็นอีเมลเพิ่มเติม สำหรับเบอร์โทรจะเปลี่ยนเป็นเบอร์หลักทันที',
          },
          {
            name: 'เมนู ⋮ → "ลบ"',
            description:
              'ลบรายการหลังยืนยันในหน้าต่าง "ลบรายการนี้?" — ค่านั้นจะใช้เข้าสู่ระบบบัญชีนี้ไม่ได้อีก',
          },
        ],
        steps: [
          'เปิดแท็บ "อีเมล/เบอร์โทร"',
          'ที่ส่วน "เพิ่มอีเมลหรือเบอร์โทรศัพท์" เลือก "ประเภท"',
          "พิมพ์อีเมล เบอร์โทร รหัสผู้ใช้งาน หรือชื่อผู้ใช้",
          'ติ๊ก "ยืนยันแล้ว (ตรวจสอบนอกระบบแล้ว)" ถ้าตรวจสอบแล้ว',
          'กดปุ่ม "เพิ่ม"',
        ],
        tips: [
          'อีเมลหลักไม่มีเมนู ลบไม่ได้ ถ้าต้องการเปลี่ยนอีเมลหลัก ให้เพิ่มอีเมลใหม่ (ยืนยันแล้ว) แล้วเลือก "ตั้งเป็นหลัก" จากนั้นจึงลบอีเมลเดิมถ้าไม่ต้องการแล้ว',
          "ผู้ใช้หนึ่งคนมีรหัสผู้ใช้งานได้หนึ่งรหัสและชื่อผู้ใช้ได้หนึ่งชื่อ ถ้าต้องการเปลี่ยน ให้ลบอันเดิมแล้วเพิ่มอันใหม่ ผู้ใช้เปลี่ยนรหัสผู้ใช้งานหรือชื่อผู้ใช้เองไม่ได้ (ตั้งเองได้ครั้งเดียวตอนสมัคร)",
          "รหัสผู้ใช้งานและชื่อผู้ใช้ใช้ร่วมกันทั้งระบบ: ค่าที่เป็นรหัสผู้ใช้งานของใครแล้ว จะเอามาเป็นชื่อผู้ใช้ไม่ได้ และกลับกัน",
          "มีอีเมลได้สูงสุด 10 รายการ (รวมอีเมลหลัก) และเบอร์โทรสูงสุด 10 เบอร์ต่อคน",
          "อีเมลหรือเบอร์หนึ่งเป็นของบัญชีเดียวทั้งระบบ ถ้าขึ้นข้อผิดพลาดว่าถูกใช้แล้ว แปลว่ามีบัญชีอื่นใช้อยู่",
          'ถ้าเห็นคำเตือนว่ายังไม่ได้ตั้งค่า SMS บนเซิร์ฟเวอร์ ผู้ใช้จะยืนยันเบอร์โทรเองไม่ได้ ให้ติ๊ก "ยืนยันแล้ว" ตอนเพิ่มเบอร์ถ้าตรวจสอบแล้ว',
        ],
        warnings: [
          "เฉพาะ owner เท่านั้นที่แก้ไขอีเมล/เบอร์โทรของบัญชี owner ได้ เพื่อป้องกันการยึดบัญชีผ่านการรีเซ็ตรหัสผ่าน",
          'ก่อนทำเครื่องหมายว่ายืนยันแล้ว ต้องแน่ใจว่าอีเมล/เบอร์นั้นเป็นของผู้ใช้จริง เพราะใครก็ตามที่ถืออีเมล/เบอร์นั้นจะใช้ "ลืมรหัสผ่าน" เข้าบัญชีได้',
        ],
      },
      {
        id: "security",
        heading: 'แท็บ "ความปลอดภัย"',
        shot: {
          file: "user-detail-security.png",
          caption: 'แท็บ "ความปลอดภัย": การยืนยันตัวตนสองขั้นตอน รหัสผ่าน และบัญชีที่เชื่อมต่อ',
        },
        fieldsTitle: "ส่วนต่าง ๆ ในแท็บความปลอดภัย",
        fields: [
          {
            name: "การยืนยันตัวตนสองขั้นตอน",
            description:
              'ป้าย "เปิดใช้งาน" หรือ "ยังไม่ได้ตั้งค่า" ถ้าเปิดอยู่จะมีปุ่ม "รีเซ็ต MFA" (ดูด้านล่าง)',
          },
          {
            name: "รหัสผ่าน",
            description: 'แสดงอีเมลหลักของผู้ใช้ พร้อมปุ่ม "ตั้งรหัสผ่านใหม่" และ "ส่งลิงก์ตั้งรหัสผ่านใหม่"',
          },
          {
            name: "บัญชีที่เชื่อมต่อ",
            description:
              'วิธีเข้าสู่ระบบที่ผูกกับบัญชี เช่น "อีเมล/รหัสผ่าน" และ google / microsoft ถ้าผู้ใช้เคยเข้าด้วยบัญชีนั้น',
          },
        ],
      },
      {
        id: "reset-mfa",
        heading: "รีเซ็ต MFA (เมื่อผู้ใช้ทำโทรศัพท์หาย)",
        body: [
          "ใช้เมื่อผู้ใช้เข้าแอปยืนยันตัวตนไม่ได้ เช่น ทำโทรศัพท์หายหรือเปลี่ยนเครื่อง และไม่มีรหัสสำรอง การรีเซ็ตจะลบแอปยืนยันตัวตนและรหัสสำรองทั้งหมดของผู้ใช้",
        ],
        steps: [
          "ยืนยันตัวตนของผู้ใช้ผ่านช่องทางที่เชื่อถือได้ก่อน (เช่น โทรกลับเบอร์ในระบบ HR หรือพบตัว)",
          'เปิดแท็บ "ความปลอดภัย" แล้วกด "รีเซ็ต MFA"',
          'อ่านข้อความยืนยัน แล้วกด "รีเซ็ต MFA" ในหน้าต่าง จะเห็นข้อความ "รีเซ็ต MFA แล้ว"',
          "แจ้งผู้ใช้ให้ตั้งค่า 2FA ใหม่ ถ้าบทบาทหรือประเภทผู้ใช้บังคับ 2FA ระบบจะพาไปหน้าตั้งค่าเองตอนเข้าสู่ระบบครั้งถัดไป",
        ],
        warnings: [
          "ระหว่างที่ยังไม่ตั้งค่าใหม่ บัญชีจะป้องกันด้วยรหัสผ่านอย่างเดียว อย่ารีเซ็ตโดยไม่ได้ยืนยันตัวตนของผู้ขอ เพราะอาจเป็นผู้ไม่หวังดีที่ได้รหัสผ่านไปแล้ว",
        ],
      },
      {
        id: "set-password",
        heading: "ตั้งรหัสผ่านใหม่ให้ผู้ใช้",
        body: [
          'ใช้เมื่อต้องการกำหนดรหัสผ่านให้ผู้ใช้โดยตรง เช่น ผู้ใช้ไม่มีอีเมลที่เข้าถึงได้ หรือระบบส่งอีเมลใช้ไม่ได้ กดปุ่ม "ตั้งรหัสผ่านใหม่" จะเปิดหน้าต่าง "ตั้งรหัสผ่านใหม่" ซึ่งแสดงอีเมล (หรือรหัสผู้ใช้งาน) ของผู้ใช้ไว้ใต้หัวเรื่อง',
          "หลังตั้งรหัสผ่าน ผู้ใช้จะถูกออกจากระบบทุกเครื่อง และเมื่อเข้าสู่ระบบครั้งถัดไปด้วยรหัสนี้ ระบบจะบังคับให้ตั้งรหัสผ่านของตัวเองก่อนจึงจะเข้าแอปใดได้",
        ],
        shot: {
          file: "user-detail-set-password.png",
          caption: 'หน้าต่าง "ตั้งรหัสผ่านใหม่" หลังให้ระบบสุ่มรหัสผ่าน — คัดลอกรหัสก่อนปิด',
        },
        fieldsTitle: "ตัวเลือกในหน้าต่างตั้งรหัสผ่าน",
        fields: [
          {
            name: "ให้ระบบสุ่มรหัสผ่าน (แสดงครั้งเดียว)",
            description:
              'ค่าเริ่มต้น (แนะนำ) ระบบสร้างรหัสผ่านสุ่มยาว 24 ตัวอักษร แสดงให้เห็นเพียงครั้งเดียวหลังกด "ตั้งรหัสผ่าน"',
          },
          {
            name: "กำหนดรหัสผ่านเอง",
            description: "พิมพ์รหัสผ่านที่ต้องการเอง จะมีช่องให้กรอกเพิ่ม 2 ช่อง",
          },
          {
            name: "รหัสผ่านใหม่",
            required: true,
            description:
              'ความยาวขั้นต่ำตามที่ตั้งไว้ในหน้า "วิธีเข้าสู่ระบบ" (ค่าเริ่มต้น 12 ตัวอักษร) สูงสุด 256 ตัว ถ้าไม่ผ่านเงื่อนไข ข้อความผิดพลาดจะแสดงใต้ช่อง',
          },
          {
            name: "ยืนยันรหัสผ่าน",
            required: true,
            description: 'พิมพ์ซ้ำให้ตรงกัน ถ้าไม่ตรงจะขึ้น "รหัสผ่านไม่ตรงกัน" และกดปุ่มตั้งรหัสผ่านไม่ได้',
          },
        ],
        steps: [
          'แท็บ "ความปลอดภัย" → กด "ตั้งรหัสผ่านใหม่"',
          'เลือก "ให้ระบบสุ่มรหัสผ่าน (แสดงครั้งเดียว)" หรือ "กำหนดรหัสผ่านเอง" แล้วกรอกรหัสผ่าน 2 ครั้ง',
          'กด "ตั้งรหัสผ่าน"',
          'จะเห็นข้อความ "ตั้งรหัสผ่านแล้ว ผู้ใช้ต้องเปลี่ยนรหัสตอนเข้าสู่ระบบครั้งถัดไป" ถ้าให้ระบบสุ่ม ให้กดปุ่มคัดลอกข้างรหัสผ่าน',
          'ส่งรหัสให้ผู้ใช้ทางช่องทางส่วนตัว แล้วกด "ปิด"',
        ],
        warnings: [
          "รหัสผ่านที่ระบบสุ่มจะไม่แสดงอีก เมื่อปิดหน้าต่างแล้วดูย้อนหลังไม่ได้ ถ้าลืมคัดลอกต้องตั้งใหม่",
          "ห้ามส่งรหัสผ่านในกลุ่มแชทหรืออีเมลที่คนอื่นเห็นได้",
          "เฉพาะ owner เท่านั้นที่ตั้งรหัสผ่านให้บัญชี owner ได้ และเฉพาะ root เองที่ตั้งรหัสผ่านของ root ได้",
        ],
      },
      {
        id: "send-reset",
        heading: "ส่งลิงก์ตั้งรหัสผ่านใหม่",
        body: [
          'ปุ่ม "ส่งลิงก์ตั้งรหัสผ่านใหม่" ส่งอีเมลพร้อมลิงก์ตั้งรหัสผ่านไปยังอีเมลหลักของผู้ใช้ทันที (ไม่มีหน้าต่างยืนยัน) จะเห็นข้อความ "ส่งอีเมลตั้งรหัสผ่านใหม่แล้ว" ลิงก์ใช้ได้ 1 ชั่วโมง',
          "วิธีนี้ปลอดภัยกว่าการตั้งรหัสผ่านให้ เพราะคุณไม่ต้องรู้รหัสผ่านของผู้ใช้ เมื่อผู้ใช้ตั้งรหัสใหม่ผ่านลิงก์ เซสชันเดิมทั้งหมดจะถูกยกเลิก และอีเมลจะถือว่ายืนยันแล้ว",
        ],
        tips: ["เหมาะกับผู้ใช้ที่ไม่ได้รับอีเมลเชิญ หรือลิงก์เชิญหมดอายุ"],
      },
      {
        id: "access",
        heading: 'แท็บ "สิทธิ์เข้าถึง": ประเภทผู้ใช้ กลุ่ม และแอปพลิเคชัน',
        body: [
          "แท็บนี้กำหนดว่าผู้ใช้เข้าแอปพลิเคชันใดขององค์กรได้บ้าง แต่ละแอปกำหนดไว้ว่ารับผู้ใช้ประเภทใดและกลุ่มใด ผู้ใช้เข้าแอปได้ถ้าประเภทของเขาหรือกลุ่มใดกลุ่มหนึ่งของเขาอยู่ในรายการของแอปนั้น",
        ],
        shot: {
          file: "user-detail-access.png",
          caption: 'แท็บ "สิทธิ์เข้าถึง": ประเภทผู้ใช้ กลุ่ม และรายการแอปพลิเคชันที่เข้าได้',
        },
        fieldsTitle: "ส่วนต่าง ๆ ในแท็บสิทธิ์เข้าถึง",
        fields: [
          {
            name: "ประเภทผู้ใช้",
            description:
              'เลือกประเภทใหม่จากรายการ แล้วกด "เปลี่ยนประเภท" (กดได้เมื่อเลือกค่าที่ต่างจากเดิม) จะมีหน้าต่างยืนยัน "เปลี่ยนประเภทผู้ใช้" บอกว่าเปลี่ยนจากอะไรเป็นอะไร กด "เปลี่ยนประเภท" อีกครั้งเพื่อยืนยัน ต้องมีสิทธิ์แก้ไขผู้ใช้',
          },
          {
            name: "กลุ่ม",
            description:
              'เลือกกลุ่มได้หลายกลุ่ม (พิมพ์เพื่อค้นหา) แล้วกด "บันทึกกลุ่ม" (กดได้เมื่อมีการเปลี่ยนแปลง) จะเห็นข้อความ "อัปเดตกลุ่มแล้ว" กลุ่มให้สิทธิ์เข้าแอปที่อนุญาตกลุ่มนั้น และแอปจะเห็นรายชื่อกลุ่มของผู้ใช้ ต้องมีสิทธิ์แก้ไขกลุ่ม (ส่วนนี้แสดงเมื่อมีสิทธิ์อ่านกลุ่ม)',
          },
          {
            name: "แอปพลิเคชัน",
            description:
              'รายชื่อแอปทั้งหมด พร้อมกฎของแอป ("ทุกคน" / ชื่อประเภทและกลุ่มที่อนุญาต / "ไม่มีใคร") ป้าย "ปิดใช้งาน" ถ้าแอปถูกปิด และผลสำหรับผู้ใช้คนนี้: "เข้าได้" หรือ "ไม่มีสิทธิ์" กดชื่อแอปเพื่อเปิดหน้าตั้งค่าของแอป (ส่วนนี้แสดงเมื่อมีสิทธิ์อ่าน OAuth clients)',
          },
        ],
        warnings: [
          "การเปลี่ยนประเภทผู้ใช้ หรือนำผู้ใช้ออกจากกลุ่ม จะเพิกถอนสิทธิ์ (token) ของแอปที่ผู้ใช้ไม่มีสิทธิ์ใช้แล้วทันที ผู้ใช้จะถูกออกจากระบบของแอปนั้น",
          'เปลี่ยนผู้ใช้ที่มีบทบาทคอนโซลจาก employee เป็นประเภทอื่นไม่ได้ ต้องเอาบทบาทออกในแท็บ "บทบาท" ก่อน',
        ],
        tips: [
          'ใช้ส่วน "แอปพลิเคชัน" ตอบคำถาม "ทำไมผู้ใช้คนนี้เข้าแอป X ไม่ได้" ได้ทันที ถ้าขึ้น "ไม่มีสิทธิ์" ให้เพิ่มผู้ใช้เข้ากลุ่มที่แอปอนุญาต หรือปรับกฎของแอป',
          "บัญชี root จะเห็นกล่องข้อความแทน: root เป็นบัญชีระบบ ไม่มีประเภทผู้ใช้ เพิ่มเข้ากลุ่มไม่ได้ และเข้าได้เฉพาะคอนโซลนี้",
        ],
      },
      {
        id: "roles",
        heading: 'แท็บ "บทบาท"',
        body: [
          'รายการบทบาททั้งหมดพร้อมคำอธิบาย ติ๊กบทบาทที่ต้องการให้ผู้ใช้ เอาติ๊กออกเพื่อถอด แล้วกด "บันทึกบทบาท" จะเห็นข้อความ "อัปเดตบทบาทแล้ว" แท็บนี้แสดงเมื่อคุณมีสิทธิ์อ่านบทบาท และแก้ไขได้เมื่อมีสิทธิ์แก้ไขบทบาท',
        ],
        tips: [
          'บทบาทคือสิทธิ์ในคอนโซลเท่านั้น ไม่เกี่ยวกับการเข้าแอปอื่น (ซึ่งใช้แท็บ "สิทธิ์เข้าถึง")',
          "ให้บทบาทน้อยที่สุดเท่าที่จำเป็น เช่น ผู้ตรวจสอบใช้ auditor ไม่ต้องใช้ admin",
          "ผู้ที่ได้บทบาทที่แก้ไขข้อมูลได้ (เช่น admin) อาจต้องตั้งค่า 2FA ก่อนเข้าคอนโซลครั้งถัดไป",
        ],
        warnings: [
          "ช่อง owner กดไม่ได้ถ้าคุณไม่ใช่ owner และ owner ถอดบทบาท owner ของตัวเองไม่ได้",
          "บทบาทคอนโซลให้ได้เฉพาะผู้ใช้ประเภท employee ถ้าผู้ใช้เป็นประเภทอื่นจะบันทึกไม่สำเร็จ",
        ],
      },
      {
        id: "sessions",
        heading: 'แท็บ "เซสชัน"',
        body: [
          'รายการอุปกรณ์/เบราว์เซอร์ที่ผู้ใช้เข้าสู่ระบบค้างไว้ คอลัมน์: "อุปกรณ์" (ข้อมูลเบราว์เซอร์และระบบปฏิบัติการ) "IP" "เริ่มเมื่อ" และ "หมดอายุ" ถ้าไม่มีจะแสดง "ไม่มีเซสชันที่ใช้งานอยู่"',
          'ปุ่ม "ยกเลิก" ท้ายแถวยกเลิกเซสชันนั้น ปุ่ม "ยกเลิกทุกเซสชัน" บนแถบเครื่องมือยกเลิกทั้งหมด ทั้งสองปุ่มทำงานทันทีโดยไม่มีหน้าต่างยืนยัน ผู้ใช้ต้องเข้าสู่ระบบใหม่ที่หน้าเข้าสู่ระบบกลาง',
        ],
        tips: [
          "ใช้เมื่อผู้ใช้แจ้งว่าลืมออกจากระบบที่เครื่องสาธารณะ หรือสงสัยว่ามีคนอื่นใช้บัญชี ควรให้ผู้ใช้เปลี่ยนรหัสผ่านด้วย",
          'แอปที่ผู้ใช้เปิดค้างไว้อาจยังใช้งานได้จนกว่าการเข้าสู่ระบบของแอปนั้นจะหมดอายุ ถ้าต้องตัดสิทธิ์ทุกแอปทันที ให้ใช้ "ระงับผู้ใช้"',
        ],
      },
      {
        id: "activity",
        heading: 'แท็บ "กิจกรรม"',
        body: [
          'ประวัติเหตุการณ์ทั้งหมดที่เกี่ยวกับผู้ใช้คนนี้จากบันทึกการใช้งาน เช่น การเข้าสู่ระบบ เข้าสู่ระบบล้มเหลว การเปลี่ยนบทบาท การตั้งรหัสผ่าน คอลัมน์: "เวลา" "เหตุการณ์" "ผู้กระทำ" (รหัสผู้ใช้ของคนที่ทำ — ผู้ใช้เองหรือผู้ดูแล) "IP" และ "User agent" (ซ่อนไว้)',
          'กดลูกศรหน้าแถว ("แสดงรายละเอียด") เพื่อดูข้อมูลเต็มของเหตุการณ์ กรองตามประเภทเหตุการณ์หรือช่วงเวลาได้จากปุ่ม "ตัวกรอง" และส่งออกเป็น CSV ได้จากปุ่ม "ส่งออก" แท็บนี้แสดงเฉพาะผู้ที่มีสิทธิ์อ่านบันทึกการใช้งาน',
        ],
      },
      {
        id: "ban",
        heading: "ระงับและยกเลิกการระงับผู้ใช้ (โซนอันตราย)",
        body: [
          'การ์ด "โซนอันตราย" อยู่ด้านล่างสุดของหน้า ปุ่ม "ระงับผู้ใช้" ใช้หยุดการใช้งานบัญชีชั่วคราว เช่น พนักงานลาออก ถูกสอบสวน หรือบัญชีถูกเจาะ โดยไม่ลบข้อมูล',
          'เมื่อระงับ: ผู้ใช้ถูกออกจากระบบทุกอุปกรณ์ สิทธิ์ (token) ของทุกแอปถูกเพิกถอน และเข้าสู่ระบบไม่ได้จนกว่าจะยกเลิกการระงับ สถานะเปลี่ยนเป็น "ถูกระงับ" และเหตุผลแสดงในการ์ดสรุป',
          'เมื่อบัญชีถูกระงับอยู่ ปุ่มจะเปลี่ยนเป็น "ยกเลิกการระงับ" กดแล้วผู้ใช้เข้าสู่ระบบได้อีกครั้งทันที (ไม่มีหน้าต่างยืนยัน)',
        ],
        shot: {
          file: "user-detail-ban.png",
          caption: 'หน้าต่างระงับผู้ใช้: ต้องกรอกเหตุผลก่อนกด "ระงับผู้ใช้"',
        },
        steps: [
          'กด "ระงับผู้ใช้" ในโซนอันตราย',
          'อ่านคำอธิบาย แล้วกรอก "เหตุผล" (บังคับ ไม่เกิน 500 ตัวอักษร เช่น "ลาออก 30 ก.ย. 2569")',
          'กด "ระงับผู้ใช้" ในหน้าต่าง จะเห็นข้อความ "ระงับผู้ใช้แล้ว"',
        ],
        tips: [
          "สำหรับพนักงานลาออก แนะนำให้ระงับแทนการลบ เพื่อเก็บประวัติและกู้คืนได้ถ้าจำเป็น",
          "ระงับบัญชีของตัวเองไม่ได้",
        ],
      },
      {
        id: "delete",
        heading: "ลบผู้ใช้ (โซนอันตราย)",
        body: [
          'ปุ่ม "ลบผู้ใช้" (สีแดง) ลบบัญชีถาวร รวมถึงโปรไฟล์ อีเมล/เบอร์โทรเพิ่มเติม รหัสผ่าน 2FA เซสชัน token ของแอป บทบาทและกลุ่ม ปุ่มนี้แสดงเฉพาะผู้ที่มีสิทธิ์ลบผู้ใช้',
          "บันทึกการใช้งานที่อ้างถึงผู้ใช้คนนี้จะยังอยู่จนครบระยะเวลาเก็บบันทึก",
        ],
        steps: [
          '(แนะนำ) กด "ส่งออกข้อมูล (PDPA)" ก่อน ถ้าอาจต้องใช้ข้อมูลภายหลัง',
          'กด "ลบผู้ใช้" ในโซนอันตราย',
          'พิมพ์อีเมลของผู้ใช้ในช่อง "อีเมล" ให้ตรงทุกตัว (ไม่สนตัวพิมพ์ใหญ่/เล็ก) ปุ่มยืนยันจะกดได้เมื่อพิมพ์ตรง',
          'กด "ลบผู้ใช้" ในหน้าต่าง จะเห็นข้อความ "ลบผู้ใช้แล้ว" และกลับไปหน้ารายชื่อผู้ใช้',
        ],
        warnings: [
          "การลบย้อนกลับไม่ได้ ถ้าสร้างบัญชีใหม่ด้วยอีเมลเดิม จะได้รหัสผู้ใช้ใหม่ และแอปพลิเคชันจะมองเป็นคนละคน",
          "ลบบัญชีของตัวเองไม่ได้",
        ],
      },
      {
        id: "root",
        heading: "ข้อจำกัดของบัญชี root และบัญชี owner",
        body: [
          "root คือบัญชีผู้ดูแลสูงสุดที่ติดมากับระบบ (รหัสผู้ใช้งาน root) เป็นบัญชีระบบที่ไม่มีประเภทผู้ใช้ ไม่มีกลุ่ม และเข้าได้เฉพาะคอนโซลนี้ เข้าแอปอื่นขององค์กรไม่ได้",
          'มีแต่ root เองเท่านั้นที่แก้ไขบัญชี root ได้ ผู้ดูแลคนอื่น (แม้เป็น owner) เปิดดูได้แต่จะไม่เห็นโซนอันตราย และการแก้ไขอื่น ๆ จะถูกปฏิเสธด้วยข้อความ "คุณไม่มีสิทธิ์ดำเนินการนี้"',
          "บัญชี owner ได้รับการป้องกันเพิ่ม: เฉพาะ owner เท่านั้นที่แก้อีเมล/เบอร์โทร ตั้งรหัสผ่าน หรือเปลี่ยนบทบาท owner ของบัญชี owner ได้",
        ],
      },
    ],
    related: ["users", "groups", "roles", "user-types", "audit-logs"],
  },
  en: {
    id: "user-detail",
    title: "User details",
    summary:
      "Everything about one user account: profile, the emails / phone numbers / user code / username used to sign in, password and 2FA, application access, console roles, active sessions, activity history, and banning or deleting the account.",
    access:
      'Anyone who may read users can view it (owner, admin, auditor). Changes need permission to change users; deleting needs permission to delete users. The "Roles" and "Activity" tabs appear only for people who may read roles and audit logs. Buttons you may not use are hidden and read-only fields are greyed out.',
    shot: {
      file: "user-detail-page.png",
      caption: "The user detail page: summary card at the top, the tabs and the danger zone at the bottom",
    },
    sections: [
      {
        id: "open",
        heading: "Opening a user",
        body: [
          'On the "Users" page, find the user and click their row. Click "Back to users" at the top left to return to the list.',
          'The page has three cards: the summary card, the tabs card (Profile, Emails & phones, Security, Access, Roles, Sessions, Activity) and the "Danger zone" card.',
        ],
      },
      {
        id: "summary",
        heading: "The summary card",
        fieldsTitle: "What the summary card shows",
        fields: [
          {
            name: "Picture, email and display name",
            description:
              'The account\'s primary email and display name. (The root account shows "root" with a "root" badge and "Built-in superuser — only root itself can change this account.")',
          },
          {
            name: "Status, type and role badges",
            description:
              'Status ("Active" / "Pending" / "Banned"), user type (e.g. employee, or "System account" for root) and one badge per console role.',
          },
          {
            name: '"Export data (PDPA)" button',
            description:
              "Downloads all data about this user as a JSON file (user-<User ID>.json), e.g. to answer a data-subject request under PDPA. Shown only to people who may export data; every export is recorded in the audit logs.",
          },
          {
            name: "User ID",
            description:
              "The long, permanent account ID (UUID) that applications receive. Use the copy button next to it.",
          },
          {
            name: "User code",
            description:
              "Shown when the user has a user code (a short code issued by the organization, used instead of the email to sign in), with a copy button.",
          },
          {
            name: "Username",
            description:
              "Shown when the user has a username (a name the user picked, used instead of the email to sign in), with a copy button.",
          },
          { name: "Created", description: "When the account was created." },
          {
            name: "Email verified",
            description:
              '"Yes" when the primary email is verified, "No" otherwise (the status is then "Pending").',
          },
          { name: "Banned: …", description: "A red box with the ban reason while the account is banned." },
        ],
      },
      {
        id: "profile",
        heading: 'The "Profile" tab',
        body: [
          'Personal and employee details. Edit and press "Save profile" at the bottom right; you see "Saved". Without permission to change users, all fields are greyed out and there is no save button.',
        ],
        fieldsTitle: "Fields on the Profile tab",
        fields: [
          {
            name: "Display name",
            description: "The name shown in the system and sent to applications (should not be empty).",
          },
          {
            name: "Employee code",
            description:
              'The HR employee number. Must be unique — a duplicate cannot be saved. (Not the same as the "User code" used to sign in, which is set on the "Emails & phones" tab.)',
          },
          { name: "First name", description: "Given name." },
          { name: "Last name", description: "Family name." },
          { name: "Department", description: "Department (the user list search also matches it)." },
          { name: "Position", description: "Job title." },
          {
            name: "Custom fields",
            description:
              'Fields your organization defined on the "Custom fields" page: text, number, date, yes/no (checkbox) or a list to choose from. Fields marked required must be filled in. Shown when such fields exist and you may read settings.',
          },
        ],
        tips: [
          "An emptied field is saved as empty (the old value is removed).",
          "Editing the profile does not sign the user out; applications see the new data at the user's next sign-in.",
        ],
      },
      {
        id: "identifiers",
        heading: 'The "Emails & phones" tab (sign-in identifiers)',
        body: [
          'An account can have several emails, several phone numbers, one user code and one username. The user can sign in with any "Verified" one, and always lands in the same account. The primary email is the account email that applications receive.',
          'The table lists them all: the value (with an icon and its type — Email / Phone / User code / Username), "Status" ("Primary" badge and "Verified" or "Not verified") and "Added". A hidden "Type" column can be turned on with "Columns".',
        ],
        shot: {
          file: "user-detail-identifiers.png",
          caption:
            'The "Emails & phones" tab: the sign-in identifiers and the "Add an email or phone number" form',
        },
        fieldsTitle: 'The "Add an email or phone number" form and the row menu',
        fields: [
          {
            name: "Type",
            required: true,
            description: 'Choose "Email", "Phone", "User code" or "Username".',
          },
          {
            name: "Email or phone number",
            required: true,
            description:
              "The value to add · email, e.g. name@example.com · phone, e.g. 081 234 5678 (national numbers are saved as +66812345678; dashes and spaces are fine) · user code, e.g. pc-00123, or username, e.g. somchai.k: 3–32 characters, letters, digits, . _ -, not 9 or more digits, not used by anyone as a user code or username.",
          },
          {
            name: "Already verified (checked outside the system)",
            description:
              "Tick when you have checked that the email / number really belongs to the user (e.g. from HR records); it can be used to sign in immediately. Otherwise the user confirms it with a code from their own account page (no code is sent automatically when an admin adds it). A user code or username always counts as verified.",
          },
          { name: '"Add" button', description: 'Adds the identifier; you see "Identifier added".' },
          {
            name: 'Row menu ⋮ → "Mark as verified"',
            description:
              "For unverified entries: makes it usable for sign-in right away (recorded in the audit logs).",
          },
          {
            name: 'Row menu ⋮ → "Make primary"',
            description:
              'For a verified email or phone that is not primary. For an email a confirmation "Make this the primary email?" appears: applications will receive this email instead, and the old primary stays as an additional email. For a phone it becomes the primary phone immediately.',
          },
          {
            name: 'Row menu ⋮ → "Remove"',
            description:
              'Removes it after the confirmation "Remove this identifier?" — the value can no longer sign in to this account.',
          },
        ],
        steps: [
          'Open the "Emails & phones" tab.',
          'Under "Add an email or phone number", choose the "Type".',
          "Type the email, phone number, user code or username.",
          'Tick "Already verified (checked outside the system)" if you checked it.',
          'Press "Add".',
        ],
        tips: [
          'The primary email has no menu and cannot be removed. To change it, add the new email (verified), choose "Make primary", then remove the old one if it is no longer needed.',
          "A user has at most one user code and one username. To change one, remove the old value and add the new one. Users cannot change their user code or username themselves (they can only pick them once, when signing up).",
          "User codes and usernames share one list across the whole system: a value that is already someone's user code cannot become a username, and the other way round.",
          "Up to 10 emails (including the primary) and 10 phone numbers per user.",
          'An email or phone number belongs to one account only across the whole system. "Already in use" means another account has it.',
          'If a warning says SMS is not configured on the server, users cannot verify phone numbers themselves — tick "Already verified" when adding a number you have checked.',
        ],
        warnings: [
          "Only owners can change an owner's emails and phone numbers — this prevents taking over an owner account via a password reset.",
          'Before marking something as verified, be sure it belongs to the user: whoever controls that email or number can use "Forgot password" to get into the account.',
        ],
      },
      {
        id: "security",
        heading: 'The "Security" tab',
        shot: {
          file: "user-detail-security.png",
          caption: 'The "Security" tab: two-factor authentication, password and linked sign-in providers',
        },
        fieldsTitle: "Sections on the Security tab",
        fields: [
          {
            name: "Two-factor authentication",
            description:
              'Badge "Enabled" or "Not enrolled". When enabled, a "Reset MFA" button appears (see below).',
          },
          {
            name: "Password",
            description:
              'Shows the user\'s primary email with the "Set password" and "Send password reset" buttons.',
          },
          {
            name: "Linked sign-in providers",
            description:
              'How the account signs in, e.g. "Email/password" plus google / microsoft if the user has signed in with them.',
          },
        ],
      },
      {
        id: "reset-mfa",
        heading: "Reset MFA (when a user lost their phone)",
        body: [
          "Use it when the user cannot use their authenticator app — lost or replaced phone — and has no backup codes. It removes the user's authenticator app and all backup codes.",
        ],
        steps: [
          "First confirm the person's identity through a trusted channel (e.g. call back the number in HR records, or in person).",
          'Open the "Security" tab and press "Reset MFA".',
          'Read the confirmation and press "Reset MFA" in the dialog; you see "MFA was reset".',
          "Tell the user to set up 2FA again. If their role or user type requires 2FA, they are taken to the setup automatically at the next sign-in.",
        ],
        warnings: [
          "Until 2FA is set up again, the account is protected by the password alone. Never reset without verifying who is asking — it could be an attacker who already has the password.",
        ],
      },
      {
        id: "set-password",
        heading: "Setting a user's password",
        body: [
          'Use it to give a user a password directly, e.g. when they cannot reach their email or email sending does not work. Press "Set password"; the "Set a new password" dialog opens with the user\'s email (or user code) under the title.',
          "Afterwards the user is signed out everywhere, and at the next sign-in with this password they must choose their own password before they can use any application.",
        ],
        shot: {
          file: "user-detail-set-password.png",
          caption: 'The "Set a new password" dialog after generating a password — copy it before closing',
        },
        fieldsTitle: "Options in the Set password dialog",
        fields: [
          {
            name: "Generate a random password (shown once)",
            description:
              'Default and recommended. The server creates a random 24-character password and shows it only once, after you press "Set password".',
          },
          { name: "Type a password", description: "Choose the password yourself; two more fields appear." },
          {
            name: "New password",
            required: true,
            description:
              'Minimum length as set on "Sign-in method" (default 12 characters), at most 256. If it does not meet the rules, the error appears under the field.',
          },
          {
            name: "Confirm password",
            required: true,
            description: 'Type it again. If it differs you see "Passwords do not match" and cannot submit.',
          },
        ],
        steps: [
          '"Security" tab → press "Set password".',
          'Choose "Generate a random password (shown once)" or "Type a password" and enter it twice.',
          'Press "Set password".',
          'You see "Password set. The user must change it at the next sign-in." For a generated password, press the copy button next to it.',
          'Give the password to the user privately, then press "Close".',
        ],
        warnings: [
          "A generated password is never shown again. Once the dialog is closed you cannot look it up — set a new one if you forgot to copy it.",
          "Never send passwords in group chats or emails other people can read.",
          "Only owners can set an owner's password, and only root can set root's password.",
        ],
      },
      {
        id: "send-reset",
        heading: "Send password reset",
        body: [
          '"Send password reset" immediately emails a link to choose a new password to the user\'s primary email (no confirmation dialog). You see "Password reset email sent". The link is valid for 1 hour.',
          "This is safer than setting a password because you never know the user's password. When the user sets a new password through the link, all their existing sessions end and the email counts as verified.",
        ],
        tips: ["Useful when the user did not receive the invitation or the invitation link expired."],
      },
      {
        id: "access",
        heading: 'The "Access" tab: user type, groups and applications',
        body: [
          "This tab decides which of the organization's applications the user may sign in to. Each application lists the user types and groups it admits; the user gets in when their type, or any of their groups, is on that list.",
        ],
        shot: {
          file: "user-detail-access.png",
          caption: 'The "Access" tab: user type, groups and the applications the user can sign in to',
        },
        fieldsTitle: "Sections on the Access tab",
        fields: [
          {
            name: "User type",
            description:
              'Pick a new type and press "Change type" (enabled once the value differs). The "Change user type" dialog shows from what to what; press "Change type" again to confirm. Needs permission to change users.',
          },
          {
            name: "Groups",
            description:
              'Pick any number of groups (type to search) and press "Save groups" (enabled when something changed); you see "Groups updated". Groups give access to applications that allow them, and applications see the user\'s groups. Needs permission to change groups (the section is shown if you may read groups).',
          },
          {
            name: "Applications",
            description:
              'Every application with its rule ("Everyone" / the allowed types and groups / "Nobody"), a "Disabled" badge if the application is switched off, and the result for this user: "Can sign in" or "No access". Click a name to open the application\'s settings. (Shown if you may read OAuth clients.)',
          },
        ],
        warnings: [
          "Changing the user type or removing a group immediately revokes the user's tokens at applications they may no longer use — they are signed out of those applications.",
          'A user who holds console roles cannot be changed from employee to another type. Remove the roles on the "Roles" tab first.',
        ],
        tips: [
          'The "Applications" list answers "why can\'t this user open application X?" at a glance. If it says "No access", add the user to a group the application allows, or adjust the application\'s rule.',
          "For the root account you see a note instead: root is a system account with no user type, it cannot join groups and signs in to this console only.",
        ],
      },
      {
        id: "roles",
        heading: 'The "Roles" tab',
        body: [
          'All roles with their descriptions. Tick the roles to give, untick to take away, then press "Save roles"; you see "Roles updated". The tab is shown if you may read roles, and editable if you may change roles.',
        ],
        tips: [
          'Roles only control the console, not other applications (use the "Access" tab for those).',
          "Give as few roles as needed — an auditor needs auditor, not admin.",
          "Someone who receives a role that can change data (e.g. admin) may have to set up 2FA before their next console visit.",
        ],
        warnings: [
          "The owner box is disabled unless you are an owner, and owners cannot remove their own owner role.",
          "Console roles can only be given to employee accounts; saving fails for other user types.",
        ],
      },
      {
        id: "sessions",
        heading: 'The "Sessions" tab',
        body: [
          'The devices / browsers where the user is signed in. Columns: "Device" (browser and operating system), "IP", "Started" and "Expires". With none you see "No active sessions".',
          '"Revoke" at the end of a row ends that session; "Revoke all sessions" in the toolbar ends them all. Both act immediately without a confirmation. The user has to sign in again on the central sign-in page.',
        ],
        tips: [
          "Use it when a user forgot to sign out on a public computer or suspects someone else used the account — and ask them to change their password too.",
          'Applications the user already has open may keep working until their own sign-in expires. To cut off every application at once, use "Ban user".',
        ],
      },
      {
        id: "activity",
        heading: 'The "Activity" tab',
        body: [
          'Every audit log event about this user: sign-ins, failed sign-ins, role changes, password changes and so on. Columns: "Time", "Event", "Actor" (the User ID of who did it — the user or an administrator), "IP" and "User agent" (hidden).',
          'Click the arrow at the start of a row ("Show details") to see the full event. Filter by event type or time with "Filters" and download CSV with "Export". The tab is shown only to people who may read audit logs.',
        ],
      },
      {
        id: "ban",
        heading: "Banning and unbanning (Danger zone)",
        body: [
          'The "Danger zone" card is at the bottom of the page. "Ban user" stops an account temporarily — e.g. the person left, is under investigation or the account was compromised — without deleting anything.',
          'When banned, the user is signed out everywhere, their tokens at every application are revoked and they cannot sign in until unbanned. The status becomes "Banned" and the reason appears in the summary card.',
          'While banned, the button changes to "Unban user"; pressing it lets the user sign in again immediately (no confirmation).',
        ],
        shot: {
          file: "user-detail-ban.png",
          caption: 'The ban dialog — a reason is required before "Ban user"',
        },
        steps: [
          'Press "Ban user" in the danger zone.',
          'Read the explanation and enter a "Reason" (required, up to 500 characters, e.g. "Left the company 30 Sep 2026").',
          'Press "Ban user" in the dialog; you see "User banned".',
        ],
        tips: [
          "For people who leave, ban rather than delete: history is kept and you can restore the account if needed.",
          "You cannot ban your own account.",
        ],
      },
      {
        id: "delete",
        heading: "Deleting a user (Danger zone)",
        body: [
          '"Delete user" (red) permanently removes the account with its profile, additional emails and phones, password, 2FA, sessions, application tokens, roles and groups. Only people who may delete users see it.',
          "Audit log entries about the user remain until the log retention period ends.",
        ],
        steps: [
          '(Recommended) Press "Export data (PDPA)" first if the data may be needed later.',
          'Press "Delete user" in the danger zone.',
          'Type the user\'s email in the "Email" field exactly (upper/lower case does not matter). The confirm button is enabled only when it matches.',
          'Press "Delete user" in the dialog; you see "User deleted" and return to the user list.',
        ],
        warnings: [
          "Deletion cannot be undone. A new account with the same email gets a new User ID, and applications treat it as a different person.",
          "You cannot delete your own account.",
        ],
      },
      {
        id: "root",
        heading: "Restrictions on the root and owner accounts",
        body: [
          "root is the built-in top administrator (user code root). It is a system account with no user type and no groups, and it can sign in to this console only — never to the organization's other applications.",
          'Only root itself can change the root account. Other administrators (even owners) can view it but do not see the danger zone, and other changes are refused with "You do not have permission to perform this action."',
          "Owner accounts are protected too: only owners can change an owner's emails / phone numbers, set an owner's password or change the owner role.",
        ],
      },
    ],
    related: ["users", "groups", "roles", "user-types", "audit-logs"],
  },
};

export default topic;
